import type { DropdownOffset } from '../types';

export const getDropdownOffset = (offset?: DropdownOffset) => {
  const o =
    typeof offset === 'number'
      ? { top: offset, right: offset }
      : (offset ?? {});
  return {
    top: o.top ?? 10,
    right: o.right ?? 10,
    bottom: o.bottom,
    left: o.left,
  };
};
